export default x => () => x;